import Typography from '@mui/material/Typography'
import React from 'react'
import {TemporaryToggle} from '../../UserManagement/UserManagementStyle'
import PropTypes from 'prop-types'
import {Grid} from '@mui/material'
import {HealthConditionSubTitle} from '../HealthCondition/HealthConditionStyle'
import {ChatbotCopyWrapper, ToggleStack} from './ChatbotCopyStyle'

const ChatbotCopy = ({selectedCopy, setSelectedCopy, disabled}) => {
  const setSelectedToggleFunction = () => {
    setSelectedCopy([1 - selectedCopy[0]])
  }

  React.useEffect(() => {
    if (disabled) {
      setSelectedCopy([0])
    }
  }, [disabled, setSelectedCopy])

  return (
    <ChatbotCopyWrapper tabIndex={0} aria-label='Agent Copy Paste'>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <HealthConditionSubTitle>Allow copy &amp; paste of chat responses</HealthConditionSubTitle>
        </Grid>
        <Grid item xs={12} md={6}>
          <ToggleStack>
            <Typography>Off</Typography>
            <TemporaryToggle
              data-testid='assistant-copy-toggle'
              checked={!!selectedCopy?.[0]}
              onChange={setSelectedToggleFunction}
              aria-label='Agent Copy Toggle Button'
              disabled={!!(disabled === undefined ? false : disabled)}
            />
            <Typography>On</Typography>
          </ToggleStack>
        </Grid>
      </Grid>
    </ChatbotCopyWrapper>
  )
}

ChatbotCopy.propTypes = {
  setSelectedCopy: PropTypes.func,
  selectedCopy: PropTypes.array,
  disabled: PropTypes.bool
}

export default ChatbotCopy
